<template>
  <q-list class="ibf-text-list2 menu-width">
    <q-item
      clickable
      class="focus-be-gone menu-item-title"
    >
      <q-item-section class="item-title ibf-gordita-12-m">{{ title }}</q-item-section>
    </q-item>
    <q-separator class="separator-class" />
    <slot />
  </q-list>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.q-item) {
  min-height: 40px !important;
}
.incredi-value-selector {
  margin: 0 10px;
}
.menu-item-title {
  padding: 12px;
}
</style>
